import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_global/landing-content')({
  beforeLoad: () => {
    // Redirect to the generic CMS admin for landing pages
    throw redirect({ to: '/page-admin/landing' as string })
  },
})
